import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import Column from "@amzn/meridian/column";
import {fetchCycles, navigationRemoved} from "../../actions/OptionsActions";
import Breadcrumb, {BreadcrumbGroup} from "@amzn/meridian/breadcrumb";
import BayTable from "./BayTable";
import Heading from "@amzn/meridian/heading";
import {FormattedMessage} from "react-intl";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";

class Bay extends Component {
    componentDidMount() {
        this.props.dispatch(fetchCycles());
        if (!this.props.machineList.length) {
            this.props.history.push(`/stowBuffer`)
        }
    }

    componentWillUnmount() {
        this.props.dispatch(navigationRemoved(0));
    }

    navigationChanged = navigationIndex => {
        this.props.dispatch(navigationRemoved(navigationIndex));
        this.props.history.push(`/stowBuffer`)
    }

    renderBreadCrumb(navigationOptions) {
        if (navigationOptions.length) {
            return (
                <Box spacingInset="small none">
                    <BreadcrumbGroup>
                        <Breadcrumb onClick={() => this.navigationChanged(0)}>
                            Machine Table
                        </Breadcrumb>
                        {navigationOptions.map((navigationOption, index) => (
                            <Breadcrumb onClick={() => this.navigationChanged(index + 1)} key={navigationOption.value}>
                                {navigationOption.value}
                            </Breadcrumb>
                        ))}
                    </BreadcrumbGroup>
                </Box>
            )
        }
    }

    render() {
        return (
            <Column spacingInset="none medium none large">
                {this.renderBreadCrumb(this.props.navigationOptions)}
                <Box spacingInset="medium none">
                    <Heading level={2} type="h400" alignment="left" spacingInset="large large large">
                        <FormattedMessage id={"bayTable.heading"}
                                          defaultMessage={"Bay Table for " + this.props.match.params.machine}/>
                    </Heading>
                    <Text color={"secondary"}><FormattedMessage id={"bayTable.description"}
                                                                defaultMessage={"This table shows the bay level drill down"}/></Text>
                </Box>
                <BayTable/>
            </Column>
        )
    }
}

const mapStateToProps = state => ({
    navigationOptions: state.optionsReducer.navigationOptions,
    machineList: state.stowBufferReducer.machineList
});

export default withRouter(connect(mapStateToProps)(Bay));



// WEBPACK FOOTER //
// ./src/components/stowBuffer/Bay.js